import React, { useContext } from 'react';
import { Modal } from 'react-bootstrap';
import useSocket from '../global/Websoket.js';
import { GlobalContext } from '../global/GlobalProvider.jsx';
import GloblePopup from '../common/GloblePopup.jsx';

function FancyBookPopup({isFancyBookPopup, receivedBookFancy, handleClose}) {

    return (
        <GloblePopup
             isOpen={isFancyBookPopup}
             onClose={handleClose}
              title="Fancy Book"
            className="login-modal"
            cancelText="Close"
        >
                <div className="fancy-book-content">
                    <table className='table'>
                        <thead>
                            <tr className="headDetail">
                                <th>Runner Name</th>
                                <th>Profit/Loss</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Ensure map returns the JSX */}
                            {receivedBookFancy?.dataToshow?.length > 0 ? (
                                receivedBookFancy.dataToshow.map((oddItem, index) => (
                                    <tr key={index}>
                                        <td>{oddItem?.message || 'N/A'}</td>
                                        <td className={oddItem?.sum < 0 ? 'red-txt' : 'green-txt'}>
                                            {oddItem?.sum || 0}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="2">No data available</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className='close-btn mt20'>
                    <button onClick={()=>handleClose()} className='btn'>Close</button>
                </div>
        </GloblePopup>
    );
}

export default FancyBookPopup;
